import React, { useState } from "react";
import { Navbar } from "./../../components";
import "./login.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import LoginImg from "./../../../assets/images/login.jpg";
import Checkbox from "@mui/material/Checkbox";
import { useAlert } from "react-alert";
import Loading from "./../../../assets/svg/loading.svg";
import { useNavigate } from "react-router-dom";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
const label = { inputProps: { "aria-label": "Checkbox demo" } };
const Login = () => {
  const navigate = useNavigate();
  const alert = useAlert();
  const [passwordShow, setPasswordShow] = React.useState(false);
  const [selectedLoginAs, setSelectedLoginAs] = React.useState("Student");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const emailInputRef = React.useRef();
  const passwordInputRef = React.useRef();
  const checkBoxHandler = () => {
    setRemember(!remember);
  };
  const LoginHandler = () => {
    if (email === "") {
      alert.error(
        <div className="alert-message">
          Type valid email address or username
        </div>
      );
      emailInputRef.current.focus();
    } else if (password === "" || password.length < 6) {
      alert.error(
        <div className="alert-message">
          You have to enter password at least 6 digit!
        </div>
      );
      passwordInputRef.current.focus();
    } else {
      setLoading(true);
      const userData = {
        email: email,
        password: password,
        remember: remember,
      };
      alert.success(
        <div className="alert-message">you have successfully signed in</div>
      );
      setTimeout(() => {
        if (selectedLoginAs === "Student") {
          navigate("/student-panel/dashboard");
          window.location.reload();
        } else if (selectedLoginAs === "Tutor") {
          navigate("/tutor-panel/dashboard");
          window.location.reload();
        } else if (selectedLoginAs === "Admin Staff") {
          navigate("/home");
        }
        setLoading(false);
      }, 2000);
    }
  };
  return (
    <div className="login-container">
      <Navbar
        title="Register"
        HeaderNavigateHandler={() => {
          navigate("/register");
        }}
      />
      <div className="login-form-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
              <div>
                <img src={LoginImg} className="login-image" />
              </div>
            </Grid>
            <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
              <div className="login-input-container">
                <p className="login-heading">Login</p>
                <p className="login-message">Good to see you again!</p>
                <p className="input-heading">Username / Email</p>
                <input
                  type="email"
                  name="email"
                  className="input"
                  placeholder="Email or Username"
                  value={email}
                  ref={emailInputRef}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <p className="input-heading">Password</p>
                <div className="password-input-container">
                  <input
                    type={passwordShow ? "text" : "password"}
                    className="password-input"
                    placeholder="Password"
                    value={password}
                    ref={passwordInputRef}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <Button
                    onClick={() => setPasswordShow(!passwordShow)}
                    className="password-show-hide-button"
                  >
                    {passwordShow ? (
                      <BsEyeFill color="#a6a6a6" size={20} />
                    ) : (
                      <BsEyeSlashFill color="#a6a6a6" size={20} />
                    )}
                  </Button>
                </div>
                <p className="input-heading">Login as</p>
                <select
                  className="input"
                  onChange={(e) => setSelectedLoginAs(e.target.value)}
                >
                  <option value="Student">Student</option>
                  <option value="Tutor">Tutor</option>
                  <option value="Admin Staff">Admin Staff</option>
                </select>
                <div className="forgot-password-main">
                  <div>
                    <Checkbox
                      {...label}
                      checked={remember}
                      onChange={checkBoxHandler}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                    />
                    <span className="check-box-title">Remember me</span>
                  </div>
                  <a href="#" className="forgot-password">
                    Forgot Password?
                  </a>
                </div>
                <Button
                  className="form-button"
                  variant="text"
                  onClick={LoginHandler}
                  disabled={loading}
                >
                  {loading ? <img src={Loading} /> : "login"}
                </Button>
                <div className="login-create-account-button-main">
                  <a
                    href="#"
                    className="login-create-account-button"
                    onClick={() => {
                      navigate("/register");
                    }}
                  >
                    Create Account
                  </a>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
};
export default Login;
